import { render, staticRenderFns } from "./SectionClientList.vue?vue&type=template&id=41507f64"
import script from "./SectionClientList.vue?vue&type=script&lang=js"
export * from "./SectionClientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports